import { Z } from "./query";

export class SuccessfulFetchResponse {
    action: 'None' | 'Alert' | 'Refresh' | 'Focus' | 'Click' | 'Redirect' | 'SetContent' | 'Reload' | 'Modal' | 'Eval' | 'Remove';
    value: string;
    icon: string = null;
    title: string = null;
    class: string = null;
    thenFocus: string = null;
}

export class FailedFetchResponse {
    action: 'None' | 'Alert' | 'Refresh' | 'Focus' | 'Click' | 'Redirect' | 'SetContent' | 'Reload' | 'Modal' | 'Eval' | 'Remove';
    errorMessage: string = null;
    field: string = null;
    thenFocus: string = null;
}

export class AppFetch {

    post(data: Record<string, any>, path: string, onSuccess: any = null, onFail: any = null, spinUp: HTMLElement = null) {
        Z.spinUp(spinUp);
        let formData = new FormData();
        Object.keys(data).forEach(key => {
            formData.append(key, data[key]);
        });

        fetch(path, {
            method: 'POST',
            body: formData,

        }).then(resp => {
            Z.spinDown();

            if (resp.ok)
                resp.json()
                    .then(json => Z.fetcher.handleSuccessfulJsonResponse(json, onSuccess));

            else
                resp.json()
                    .then(json => Z.fetcher.handleFailedJsonResponse(json, onFail));
        });
    }

    get(src: HTMLElement | string, path: string, onSuccess: any = null, onFail: any = null) {
        if (typeof (src) === 'string') {
            path = <string>src;
            src = null;
        }

        if (src !== undefined)
            Z.spinUp(<HTMLElement>src);

        fetch(path).then(resp => {
            Z.spinDown();
            console.log(`fetcher.get(${path}) => `, resp);

            if (resp.ok) {
                resp.text()
                    .then(text => {
                        console.log(`<<[ok] ${text}`);
                        try {
                            let json = JSON.parse(text);
                            Z.fetcher.handleSuccessfulJsonResponse(json, onSuccess);
                        } catch {
                            Z.fetcher.handleSuccessfulJsonResponse(null, onSuccess);
                        }
                    });
            }

            else {

                resp.text()
                    .then(text => {
                        console.log(`<<[err] ${text}`);
                        try {
                            let json = JSON.parse(text);
                            Z.fetcher.handleFailedJsonResponse(json, onFail);
                        } catch {
                            Z.fetcher.handleFailedJsonResponse(null, onFail);
                        }
                    });
            }
        });
    }

    handleSuccessfulJsonResponse(resp: SuccessfulFetchResponse, onSuccess: any = null, actualResponse: any = null) {
        //R.logIf(this.deepLog, `successful JSON response: [${resp}]`, resp, onSuccess);
        console.log(`handle successful JSON response`, resp);

        if (!resp || !resp.action) {
            if (onSuccess)
                onSuccess(actualResponse);
            return;
        }

        let field = resp.thenFocus;
        let fieldElement: HTMLElement = null;

        if (field) {
            if (!(fieldElement = document.querySelector(field))) {
                fieldElement = document.querySelector(`[name="${field}"]`);
            }
        }

        //R.logIf(this.deepLog, `successful JSON response: ${resp.action}`, resp, onSuccess, fieldElement);

        if (resp.action == 'Remove') {
            try {
                Z.forEach(resp.value, el => el.remove());
            } catch (err) { }
        }

        if (resp.action == 'Alert') {
            /* let modalOpen = document.body.classList.contains('modal-open');
            Z.dismissModal();
            if (modalOpen) {
                setTimeout(() => {
                    Z.confirm({
                        class: resp.class || 'primary',
                        icon: resp.icon || 'info-circle',
                        text: resp.value,
                        prompt: resp.title,
                        confirmButton: false,
                        dismissText: 'Dismiss',
                    });
                }, 500);
            } else { */
                Z.confirm({
                    class: resp.class || 'primary',
                    icon: resp.icon || 'info-circle',
                    text: resp.value,
                    prompt: resp.title,
                    confirmButton: false,
                    dismissText: 'Dismiss',
                });
            //}
        }

        if (resp.action == 'Modal') {
            Z.dismissModal();
            Z.showModal(resp.value);
        }

        else if (resp.action == 'Click') {
            if (fieldElement) fieldElement.click();
        }

        else if (resp.action == 'Focus') {
            if (fieldElement) {
                fieldElement.focus();
                if ((fieldElement as any).select) (fieldElement as any).select();
            }
        }

        else if (resp.action == 'None') {
            // ?
        }

        else if (resp.action == 'Redirect') {
            if (`${resp.value}`.toLowerCase().startsWith('<download>')) {
                window.open(resp.value.substring('<download>'.length));
            } else {
                Z.spinUp(fieldElement || null);
                location.href = resp.value;
            }
        }

        else if (resp.action == 'Refresh') {
            Z.spinUp(fieldElement);
            if (onSuccess && typeof onSuccess === 'function') {
                let result = onSuccess();
                if (result === false)
                    return;
            }
            location.reload();
        }

        else if (resp.action == 'Reload') {
            let selector = resp.value;
            let selected = document.querySelector(selector);
            if (selected) {
                fetch(location.href)
                    .then(resp => {
                        if (resp.ok) {
                            resp.text()
                                .then(html => {
                                    let parser = new DOMParser();
                                    let doc = parser.parseFromString(html, 'text/html');
                                    let replacement = doc.querySelector(selector);
                                    if (replacement) {
                                        selected.replaceWith(replacement);
                                        document.dispatchEvent(new Event('received-gui'));
                                    }
                                });
                        }
                    });
            }
        }

        else if (resp.action == 'SetContent') {
            if (fieldElement) {
                fieldElement.innerHTML = resp.value;
            }
        }

        if (onSuccess && typeof onSuccess === 'function')
            onSuccess();
    }
    handleFailedJsonResponse(resp: FailedFetchResponse, onFail: any = null) {

        console.log(`handle failed JSON response`, resp);
        if (!resp) {
            if (onFail) onFail();
            return;
        }

        let field = resp.field;
        let fieldElement: HTMLElement = null;
        if (field) {
            if (!(fieldElement = document.querySelector(field))) {
                fieldElement = document.querySelector(`[name="${field}"]`);
            }
        }

        if (resp.action == 'Remove') {
            try {
                Z.forEach(resp.field, el => el.remove());
            } catch (err) { }
        }

        if (resp.action == 'Alert') {
            Z.confirm({
                class: 'danger',
                icon: 'exclamation-triangle',
                text: resp.errorMessage,
                prompt: 'Error',
                confirmButton: false,
                dismissText: 'Dismiss',
            });
        }

        else if (resp.action == 'Click') {
            if (fieldElement) fieldElement.click();
        }

        else if (resp.action == 'Focus') {
            if (fieldElement) {
                fieldElement.focus();

                if ((fieldElement as any).select)
                    (fieldElement as any).select();

                Z.setInvalidFeedback(fieldElement, resp.errorMessage);

                /*fieldElement.classList.add('is-invalid');
                let feedback = fieldElement.getAttribute('aria-labelledby');

                if (feedback) {
                    let feedbackElement = document.getElementById(feedback);

                    if (feedbackElement) {
                        feedbackElement.textContent = resp.errorMessage;
                    }
                } else {

                    if (fieldElement.matches('.error-feedback')) {
                        fieldElement.innerText = resp.errorMessage;
                    }

                }*/
            }
        }

        else if (resp.action == 'None') {
            // ?
        }

        else if (resp.action == 'Redirect') {
            Z.spinUp(fieldElement || null);
            location.href = resp.errorMessage;
        }

        else if (resp.action == 'Refresh') {
            Z.spinUp(fieldElement);
            location.reload();
        }

        else if (resp.action == 'SetContent') {
            if (fieldElement) {
                fieldElement.innerHTML = resp.errorMessage;
            }
        }

        if (resp.thenFocus) {
            let thenFocus = document.querySelector(resp.thenFocus);
            if (thenFocus) {
                fieldElement.focus();
                if ((fieldElement as any).select) (fieldElement as any).select();
            }
        }
    }

}